import React from "react";
import { Routes, Route } from "react-router-dom";

// Main components
import FacilityManagementDashboard from "./index";
import StoringenPage from "./storingen";
// import StoringDetail from "./Components/StoringDetail";
import StoringForm from "./Components/StoringForm";
import StoringDetail from "./Components/StoringDetail";
import CategoriesPage from "./Components/CategoriesPage";
// import AccommodatiesPage from "./accommodaties";
// import AccommodatieDetail from "./Components/AccommodatieDetail";
// import AccommodatieForm from "./Components/AccommodatieForm";
// import WerkordersPage from "./werkorders";
// import WerkorderDetail from "./Components/WerkorderDetail";
// import WerkorderForm from "./Components/WerkorderForm";
// import CategoriesPage from "./categories";

const FacilityManagementRouter = () => {
  return (
    <div className="content-wrapper">
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <h1>Facility Management</h1>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <Routes>
            {/* Dashboard */}
            <Route path="/" element={<FacilityManagementDashboard />} />
            
            {/* Storingen Routes */}
            <Route path="/storingen" element={<StoringenPage />} />
            <Route path="/storingen/nieuw" element={<StoringForm />} />
            <Route path="/storingen/:id" element={<StoringDetail />} />
            <Route path="/storingen/:id/edit" element={<StoringForm />} />
            
            {/* Accommodaties Routes */}
            {/* <Route path="/accommodaties" element={<AccommodatiesPage />} />
            <Route path="/accommodaties/nieuw" element={<AccommodatieForm />} />
            <Route path="/accommodaties/:id" element={<AccommodatieDetail />} />
            <Route path="/accommodaties/:id/edit" element={<AccommodatieForm />} /> */}
            
            {/* Werkorders Routes */}
            {/* <Route path="/werkorders" element={<WerkordersPage />} />
            <Route path="/werkorders/nieuw" element={<WerkorderForm />} />
            <Route path="/werkorders/:id" element={<WerkorderDetail />} />
            <Route path="/werkorders/:id/edit" element={<WerkorderForm />} /> */}
            
            {/* Categories Routes */}
            <Route path="/categories" element={<CategoriesPage />} />
            
            {/* Catch all - redirect to dashboard */}
            <Route path="*" element={<FacilityManagementDashboard />} />
          </Routes>
        </div>
      </section>
    </div>
  );
};

export default FacilityManagementRouter;